module.exports = __webpack_public_path__ + "img/xp.49739f77.png";